<template>
	<div class="page-mdl">
		
		<!-- 列表 -->
		<section class="page-ctn w1200">
			<div class="page-main">
				<!-- 面包屑 -->
				<div class="bread-crumbs">
					<span>您现在的位置是：</span><a href="javascript:;" @click="goUrl({name:'pageIndex'})">首页</a> > <p>{{newsListInfo.catename}}</p>
				</div>
				
				
				<ul class="news-list" v-if="newsListInfo.list">
					<li v-for="(item2,index2) in newsListInfo.list.list" :key="item2.id" @click="goUrl({ name:'pageDetail', params:{ id:item2.id}})">
						<!-- <span class="date">{{item2.inputtime}}</span> -->
						<i class="dot"></i><p>{{item2.title}}</p>
					</li>
				</ul>
				
				<div class="paging" v-if="newsListInfo.list">
					<span class="prev" :class="{show:pageNum>1}" @click="changeList(-1)">上一页</span>
					<p>{{pageNum}}/{{pageLen}}</p>
					<span class="next" :class="{show:pageNum < pageLen}" @click="changeList(1)">下一页</span>
				</div>
			</div>
		</section>
		
		
		<section class="friend-link">
			<div class="w1200">
				<h2 class="title">相关链接：</h2>
				<div class="link-list" v-if="friendLink">
					<a :href="item.url" target="_blank" v-for="(item,index) in friendLink" :key="index">{{item.name}}</a>
				</div>
			</div>
		</section>
		
		<!-- 通用底部 -->
		<footer class="footer">
			<span>版权所有：国家开放大学宣传部（新闻中心）</span>
			<span>技术支持：国开在线教育科技有限公司 </span>
		</footer>
	</div>
</template>

<script>
import pageMixin from '@/mixins/page.js'
export default {
	mixins: [pageMixin],
	name: 'pageIndex',
	data () {
		return {
			catid:'',
			newsListInfo:{},
			pageNum:1,
			pageSize:10,
			pageLen:1,	//总页数
		}
	},
	
	created(){
		this.catid = this.$route.params.catid
		this.getListInfo()
	},

	
	//防止
	beforeRouteUpdate (to, from, next) {
		this.catid = to.params.catid?to.params.catid:''
		this.getListInfo()
		next() // 一定要有next
	},
  
	methods:{
		//获取列表
		getListInfo(){
			if(this.listLoading){return}
			this.listLoading = true
			this.$axios({
				url:'/index.php?s=common&c=api&m=getNewList',
				params:{
					catid	: this.catid,
					page	: this.pageNum,
					limit	: this.pageSize
				},
				success:(res)=>{
					this.newsListInfo = res.data
					this.pageLen = Math.ceil(res.data.list.total/this.pageSize)
				},
				complete:()=>{
					this.listLoading = false
				}
			})
		},
		//切换分页
		changeList(num){
			if(num<0 && this.pageNum<=1){return}
			if(num>0 && this.pageNum>=this.pageLen){return}
			this.pageNum += num
			this.getListInfo()
		},
		
	}
}
</script>

<style lang="less" scoped>
.page-mdl{ background:#fff9f1; padding-top:0;}
.news-list{
	margin:0 40px;
	li{ 
		height:46px; line-height:46px; overflow:hidden; border-bottom:1px dotted #999;
		.date{font-size:14px; color:#999; line-height:46px; float:right; }
		.dot{ float:left; width:6px; height:6px; background:#666666; border-radius:100%; margin-top:20px; margin-right:15px; }
		p{font-size:16px; color:#666; line-height:46px;display: block; text-overflow:ellipsis; white-space:nowrap; overflow:hidden; cursor: pointer;
			&:hover{text-decoration: underline;}
		}
		&:last-child{border-bottom:none;}
	}
}
.paging{
	margin-top:70px; text-align:center;
	p{width:100px; font-size:20px; color:#666; line-height:39px; display:inline-block;  vertical-align: top;}
	span{
		height:39px;width:84px; display:inline-block; background:url(~@/assets/img/pag-prev.png) no-repeat; font-size:0; cursor: text; vertical-align: top;opacity: .5;
		&.next{ background:url(~@/assets/img/pag-next.png) no-repeat;}
		&.show{ opacity: 1; cursor: pointer; }
		&.show:hover{opacity: .8;}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/list/index.vue